<template>
    <div class="section">
        <b-loading :is-full-page="false" :active.sync="loading" :can-cancel="true"></b-loading>
        <div class="columns is-multiline is-centered">
            <div v-if="entries.length > 3 || first3.length == 3" class="column is-two-thirds">
                <p class="title">Lo mas reciente</p>
                <Featured v-if="entries.length > 3 || first3.length == 3" :entries="first3"/>
            </div>
        </div>
        <div class="columns is-multiline is-centered m-t-15 m-b-15">
            <div class="column is-two-thirds ">
                <p class="title ">Todos los articulos</p>
                <p class="heading">Secciones</p>

                <b-button
                class="m-l-10"
                rounded
                @click="sectionChanged(false)"
                :type="!selectedSection? 'is-custom' : 'is-dark'"
                >
                    Todos
                </b-button>

                <b-button
                v-for="sec in sections"
                :key="sec.id"
                class="m-l-10"
                rounded
                @click="sectionChanged(sec.id)"
                :type="selectedSection == sec.id ? 'is-custom' : 'is-light'"
                >
                    {{sec.title}}
                </b-button>
            </div>
        </div>
        <div class="columns is-multiline is-centered">
            <div class="column is-two-thirds">
                <p class="heading ">Articulos</p>
                <article v-for="e in entries" :key="e" class="media">
                    <figure class="media-left">
                        <div class="image is-128x128"
                        :style="`background-image:url(${e.thumbnail}); background-position:center; background-size:cover;`">
                        </div>
                    </figure>
                    <div class="media-content">
                        <div class="content">
                        <p>
                            <strong>{{e.title}}</strong> - <small>{{ new Date(entries[0].timestamp).toLocaleDateString() }}</small> - <small>{{e.authorName}}</small> - <span v-if="e.sectionObj" class="tag is-small is-rounded is-custom m-l-5">{{e.sectionObj.title}}</span>
                        </p>
                        <p>{{e.description}}</p>
                        <a :href="e.getPublicDetail">Leer mas</a>
                        </div>
                    </div>
                </article>
            </div>
        </div>
        <div class="columns is-multiline is-centered">
            <div class="column is-two-thirds p-t-20">
                <b-pagination
                :total="count"
                :per-page="perPage"
                :current.sync="page"
                :range-before="2"
                :rounded="true"
                :range-after="2"
                order="is-centered"
                @change="onPageChange"
                icon-prev="chevron-left"
                icon-next="chevron-right"
                >
                </b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import Featured from './components/Featured.vue'
import { getHandler } from '../../../services/http'
export default {
    components:{
        Featured,
    },
    props:{
        blogList:{
            type:String,
            default:""
        },
        blogSections:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            entries:[],
            loading:false,
            count:0,
            page:1,
            perPage:24,
            sections:[],
            selectedSection:"",
            initialR: true,
            first3: []
        }
    },
    methods:{
        async fetchEntries(){
            this.loading = true
            var url = this.blogList + `?page=${this.page}`
            if(this.selectedSection){
                url = url + `&section=${this.selectedSection}`
            }
            let resp = await getHandler(url, {error:false, success:false})
            this.loading = false
            this.count = resp.count
            this.entries = resp.results
            if (this.initialR){
                console.log("heeey")
                this.first3 = this.entries.slice(0, 3)
            } else{
                this.first3 = this.first3
            }
        },
        async fetchSections(){
            this.loading = true
            this.sections = await getHandler(this.blogSections, {error:false, success:false})
            this.loading = false
        },
        onPageChange(page){
            this.initialR = false
            this.page = page
            this.fetchEntries()
        },
        sectionChanged(sec){
            this.selectedSection = sec
            this.initialR = false
            this.page = 1
            this.fetchEntries()
        }
    },
    created(){
        this.fetchEntries();
        this.fetchSections();
    }
}
</script>

<style lang="scss" scoped>
.blog-card{
    border-radius: 5%;
    transition: all 1s;
    overflow: hidden;
}
.card-image{
    overflow: hidden;
    padding:10px;
}
.is-custom{
    color:var(--text-color);
    background:var(--primary);
}


.image{
    overflow: hidden;
    border-radius: 5%;
}

.img-hover{
    
    img{
        transition: all 1s;
    }
}

.card-hover:hover {
    box-shadow: 1px 10px 10px #b8b8b8;
    .img-hover{
        img{
            transform: scale(1.1);
        }
    }
}
</style>